import { mergeDeep } from '@/helpers/utils'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import ageYoungPng from '@/assets/landing-age-selection/main-gs/age-18.png'
import age40FlippedPng from '@/assets/landing-age-selection/main-gs/age-40-flipped.png'
import age50FlippedPng from '@/assets/landing-age-selection/main-gs/age-50-flipped.png'
import age70Png from '@/assets/landing-age-selection/main-gs/age-70.png'

export default (schemas: LandingScreenSchema[]): LandingScreenSchema[] => {
	const extensionSchema: Partial<LandingScreenSchema>[] = [
		{
			// loader-main
		},
		{
			// age-main: four clickable age cards (18-39 promoted from the escape link,
			// 60-69 + 70+ collapsed into 60-80), couple photos instead of single models.
			// Labels are hardcoded EN — web.json has no 18_39 / 60_80 keys (GT-4666).
			components: {
				LandingAgeGrid: (): LandingComponentsConfig['LandingAgeGrid'] => ({
					theme: 'blue',
					ageRanges: [
						{
							value: 18,
							analyticValue: '18-39',
							label: 'Age: 18–39',
							img: ageYoungPng,
						},
						{
							value: 40,
							analyticValue: '40-49',
							label: 'Age: 40–49',
							img: age40FlippedPng,
						},
						{
							value: 50,
							analyticValue: '50-59',
							label: 'Age: 50-59',
							img: age50FlippedPng,
						},
						{
							value: 60,
							analyticValue: '60-80',
							label: 'Age: 60–80',
							img: age70Png,
						},
					],
				}),
			},
		},
	]

	return mergeDeep([...schemas], extensionSchema)
}
